<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? 'Editar concepto de pago operativo' : 'Nuevo concepto de pago operativo' }}</h1>
    </div>
    <form class="custom-form" @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos del concepto' : 'Datos del nuevo concepto'">
        <section class="form-section mb-0">
          <div class="flex flex-wrap -mx-2">
            <div v-if="editing" class="w-full md:w-1/2 px-2">
              <div class="mb-3">
                <wz-input label="Código" v-model="form.code" :disabled="true" />
              </div>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <div class="mb-3">
                <wz-input
                  label="Nombre"
                  required
                  v-model="form.name"
                  placeholder="Ej: Movilidad"
                  :error="$v.form.name.$error && !$v.form.name.required ? 'Nombre es requerido' : ''"
                />
              </div>
            </div>
            <div class="w-full px-2">
              <div class="mb-3 mb-0">
                <wz-textarea
                  label="Descripción"
                  v-model="form.description"
                  :rows="2"
                  placeholder="Descripción opcional"
                />
              </div>
            </div>
          </div>
        </section>
        <div class="mb-3 text-right">
          <wz-button variant="light" type="button" @click="$router.push({ name: 'operational-payment-concept-list' })">{{ editing ? 'Volver' : 'Cancelar' }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>
  </div>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { OperationalPaymentConceptService } from '@/core/services'
import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      form: { code: null, name: null, description: null },
      editing: false,
    }
  },
  validations: {
    form: {
      name: { required },
    },
  },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        let response
        if (!this.editing) response = await OperationalPaymentConceptService.save(this.form)
        else response = await OperationalPaymentConceptService.update(this.$route.params.id, this.form)
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) {
          this.$router.push({ name: 'operational-payment-concept-edit', params: { id: response.payload.id } })
          this.editing = true
        }
      } catch (ex) {
        console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar')
      } finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const resp = await OperationalPaymentConceptService.get(id)
        this.form = { ...resp.payload }
        this.editing = true
      } catch (e) {
        console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar')
        this.$router.push({ name: 'operational-payment-concept-list' })
      } finally { this.$store.dispatch('app/loading', false) }
    },
  },
  created() { if (this.$route.params.id) this.load(this.$route.params.id) },
}
</script>
